@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentWebsiteBlackStepsThird {
  display: flex;

  .entry {
    border-radius: 22px;
    border: 1px solid var(--web-border-white);
    background: var(--web-background-grid-white);
    padding: 25px;
    width: 30%;
    position: relative;
    display: flex;
    flex-direction: column;

    .names {
      display: flex;
      flex-direction: column;
      gap: 25px;
      position: relative;
      z-index: 1;

      .title {
        font-size: 20px;
        display: block;
        align-items: center;
        gap: 10px;

        @include texts.font("semi-bold");

        .step {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 13px;
          height: 15px;
          margin-right: 2px;

          .stepShadow {
            height: 1px;
            box-shadow: 0 0 20px 8px var(--white);
            position: absolute;
          }

          .text {
            position: absolute;

            @include texts.font("semi-bold");
          }
        }

        h4 {
          display: inline;
        }
      }

      .description {
        font-size: 15px;
      }
    }

    .imageContainer {
      width: 100%;
      position: relative;
      bottom: -25px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: auto;
      z-index: 1;

      .image {
        width: 100%;
        border-radius: 12px 12px 0px 0px;
      }
    }

    .shadow {
      width: 84px;
      height: 84px;
      background: var(--white);
      filter: blur(85px);
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }

  .separator {
    height: 40px;
    width: 40px;
    flex: 0 0 40px;
    margin: auto 25px;
    opacity: 0.2;
    filter: var(--icon-white);

    @include icons.ico("black-right-arrow");
  }

  @media screen and (max-width: 930px) {
    flex-direction: column;
    gap: 15px;

    .entry {
      width: calc(100% - 50px);
    }

    .separator {
      display: none;
    }
  }
}